<template>
  <div class="cart-widget__item">
    <div>
      <LazyBackgroundMedia
          v-if="hasCategoryImage"
          class="cart-widget__item__icon"
          icon
          :media-url="product.category.image?.url"
          background-position-y="center"
          background-position-x="center"
          no-repeat
      />
    </div>
    <div>
      <div class="cart-widget__item__title">
        <div>{{ product.name }}</div>
        <div>
          <button
              class="btn-remove-item"
              @click="$.emit('remove')"
          >
            <FontAwesomeIcon :icon="faTrashAlt" />
          </button>
        </div>
      </div>
      <div class="cart-widget__item__price">
        <div>pro Monat</div>
        <div>{{ product.getPriceFormatted('monthly') }}&thinsp;€</div>
      </div>
      <div class="card-widget__item__details">
        <Expand title="Produktdetails">
          <PriceDetailsTable
              :product="product"
              :key="`details-${itemKey}`"
          />
        </Expand>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import Product from '@/classes/Product';
import Expand from '@/components/Expand.vue';
import PriceDetailsTable from '@/components/product/PriceDetailsTable.vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faTrashAlt } from '@fortawesome/pro-light-svg-icons';
import { computed } from 'vue';

library.add(faTrashAlt);

const props = defineProps<{
  itemKey: string
  product: Product
}>();

const hasCategoryImage = computed(() => !!props.product.category.image?.url);
</script>

<style lang="scss">
@import "src/scss/component-helpers";

.cart-widget__item {
  display: grid;
  gap: 20px;
  grid-template-columns: auto 1fr;
  align-items: start;

  @media(min-width: map-get($grid-breakpoints, 'lg')) {
    gap: 30px;
  }

  > div:last-child {
    display: grid;
    grid-template-columns: 100%;
    gap: 10px;
  }

  &__icon {
    font-size: 70px;
    background-color: #fff;
    width: 1em;
    height: 1em;
    z-index: 3;

    .icon {
      background-size: contain;
    }

    @media(min-width: map-get($grid-breakpoints, 'lg')) {
      font-size: 90px;
    }
  }

  &__title, &__price {
    display: grid;
    grid-template-columns: auto auto;
    justify-content: space-between;
  }

  &__title {
    line-height: 1;

    > div {
      &:first-child {
        font-weight: 700;
        font-size: 1.125rem;

        @media (min-width: map_get($grid-breakpoints, 'lg')) {
          font-size: 1.5rem;
        }
      }
    }
  }

  &__price {
    > div {
      &:last-child {
        font-weight: 700;
      }
    }
  }

  .btn-remove-item {
    font-size: 28px;
    border: 0;
    background: transparent;
    padding: 0;
    outline: 0;
    color: #F93F4D;
    line-height: 0;
  }
}
</style>
